module.exports = __webpack_public_path__ + "img/sass.f06c6924.png";